// Wraps a dynamic import so that, when loading a chunk fails, we force a one-time full page reload to fetch fresh assets.
//
// This happens when a deploy replaces the hashed chunk filenames while a user still has a stale tab open: navigating then triggers an import of a chunk that no longer exists. We may serve a text/html error page on missing files, which can cause "'text/html' is not a valid JavaScript MIME type".
//
// We guard against reload loops with a sessionStorage flag, so a genuinely broken chunk still throws.
//
// This assumes at most one wrapped import is in flight at a time, which holds today because the router only renders one lazy page. If you add route prefetching or otherwise load wrapped pages concurrently, revisit this: a concurrent success clears the flag and could defeat the loop guard.

const RELOAD_FLAG = 'live-bidding:chunk-reload-attempted'

export default function importWithReload(importFn) {
  return async () => {
    try {
      const module = await importFn()
      window.sessionStorage.removeItem(RELOAD_FLAG)
      return module
    } catch (error) {
      if (window.sessionStorage.getItem(RELOAD_FLAG)) throw error

      window.sessionStorage.setItem(RELOAD_FLAG, '1')

      const disallowReloadingFromCache = true
      window.location.reload(disallowReloadingFromCache)

      // A Promise that never settles, so React shows a loading state until the reload kicks in.
      return new Promise(() => {})
    }
  }
}
